<!--
 * @Author: wufei
 * @Date: 2020-08-14 09:55:35
 * @LastEditTime: 2020-08-20 15:22:02
 * @Description:
 * @FilePath: \mobile-revive\src\views\report\reviveReport\month.vue
-->
<template>
  <div class="revive-month">
    <report-menu :cur="active" :is-obtains="isObtains" @switchMenu="switchMenu" />

    <!-- 项目复盘 start -->
    <div class="first-revive mt20">
      <title-comp title="项目复盘" :title-line="true">
        <template v-slot:content>
          <div class="content">
            <ell :params="{content:monthlyForm.reviveRemarks || '--', renderState:renderState, line:2}" />
          </div>
        </template>
      </title-comp>
    </div>
    <!-- 项目复盘 end -->

    <!-- 量价对比 start -->
    <div class="first-revive">
      <title-comp title="量价对比" :title-line="true">
        <template v-slot:content>
          <div class="content">
            <table class="qp-table" cellspacing="0" cellpadding="0">
              <thead>
                <tr>
                  <td />
                  <td>投资版</td>
                  <td>动态版</td>
                  <td>偏差</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>整盘均价(元/㎡)</td>
                  <td>{{ monthlyForm.investAvgPrice | keepInteger | unitFormat }}</td>
                  <td>{{ monthlyForm.dynamicAvgPrice | keepInteger | unitFormat }}</td>
                  <td class="c-red">{{ monthlyForm.investAvgPrice | dataBias(monthlyForm.dynamicAvgPrice) }}</td>
                </tr>
                <tr>
                  <td>月均流量（㎡/月）</td>
                  <td>{{ monthlyForm.investMonthFlow | keepInteger | unitFormat }}</td>
                  <td>{{ monthlyForm.dynamicMonthFlow | keepInteger | unitFormat }}</td>
                  <td class="c-red">{{ monthlyForm.investMonthFlow | dataBias(monthlyForm.dynamicMonthFlow) }}</td>
                </tr>
                <tr>
                  <td>年涨幅(%)</td>
                  <td>{{ monthlyForm.investYearGains | keepInteger(1) | unitFormat }}</td>
                  <td>{{ monthlyForm.dynamicYearGains | keepInteger(1) | unitFormat }}</td>
                  <td class="c-blue">{{ monthlyForm.investYearGains | dataBias1(monthlyForm.dynamicYearGains) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </title-comp>
    </div>
    <!-- 量价对比 end -->

    <!-- 量价走势 start -->
    <div class="first-revive">
      <title-comp title="量价走势" :title-line="true">
        <template v-slot:content>
          <div class="content">
            <div class="bar-container">
              <div ref="barCharts" class="myCharts bar-chart" />
            </div>
          </div>
        </template>
      </title-comp>
    </div>
    <!-- 量价走势 end -->

    <div v-if="file && file.pkId" class="view-detail">
      <icon name="description" />
      <div>查看详细</div>
      <div>复盘报告</div>
    </div>
  </div>
</template>

<script>
import { priceTend } from '@/api/revive'
import TitleComp from '@/components/TitleComp'
import reportMenu from './menu'
import ell from '@/components/Ell'
import { Lazyload, Icon } from 'vant'
import moment from 'moment'
import { getMonthRevive } from '@/api/revive'
import { getNewReplayFrom } from '@/api/revive'
export default {
    name: 'ReviveMonth',
    components: {
        TitleComp,
        reportMenu,
        ell,
        Icon
    },
    filters: {
        // 计算数据偏差
        dataBias(data1, data2) {
            var iData
            if (data1 && data2) {
                iData = (Number(data2) - Number(data1)) / Number(data1)
                return parseFloat(iData * 100).toFixed(1) + '%'
            } else if (data2 == 0 && !data1) {
                return '-100%'
            }
            return '--'
        },
        dataBias1(data1, data2) {
            var iData
            if (data1 && data2) {
                iData = Number(data2) - Number(data1)
                return parseFloat(iData).toFixed(1) + '%'
            } else if (data1 == 0 || data2 == 0) {
                iData = (data2 !== 0 ? Number(data2) : 0) - (data1 !== 0 ? Number(data1) : 0)
                return parseFloat(iData).toFixed(1) + '%'
            }
            return '--'
        }
    },
    props: {
        active: {
            type: String,
            default: 'basic'
        }
        // monthlyForm: {
        //     type: Object,
        //     default: () => { return {} }
        // }
    },
    data() {
        return {
            landId: this.$route.query['landId'],
            renderState: false,
            chartData: {
                xAxisData: [],
                flowList: [], // 投资版流量
                priceList: [], // 投资版价格
                actualFlow: [], // 实际流量
                actualPrice: [], // 实际价格
                startMonth: '',
                endMonth: '',
                systemTime: ''
            },
            monthlyForm: {},
            isObtains: 0,
            file: {}

        }
    },
    created() {
        this.addDate()
        this.fetchMonthRevive()
        this.fetchReplayFrom()
    },
    mounted() {
        this.initLineChart()
    },
    methods: {
        // 查询复盘from
        fetchReplayFrom() {
            getNewReplayFrom(this.landId).then(res => {
                this.replayForm = res || {}
                this.devEnterprise = res.housingPrices ? res.housingPrices.split(',') : []
                this.isObtains = res.isObtains // 是否我司获取
            })
        },
        // 获取当前年月
        addDate() {
            let nowDate = new Date()
            let date = {
                year: nowDate.getFullYear(),
                month: (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1,
                date: nowDate.getDate()
            }
            this.systemTime = date.year + '-' + date.month + '-' + date.date
        },
        // 获取月度复盘data
        fetchMonthRevive() {
            const landId = this.landId
            const version = this.systemTime
            getMonthRevive(landId, version).then(res => {
                if (res) {
                    this.monthlyForm = res
                    this.renderState = true
                }
            })
        },
        async initLineChart() {
            await this.priceTend()
            setTimeout(() => {
                const barChart = this.$echarts.init(this.$refs.barCharts)
                barChart.setOption({
                    tooltip: {
                        trigger: 'axis',
                        confine: true,
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        },
                        textStyle: {
                            fontSize: 12
                        },
                        formatter: function(data) {
                            let html = '<div>'
                            data.forEach(item => {
                                const arr = item.seriesName.split('(')
                                const name = arr[0]
                                const unit = arr[1].replace(')', '')
                                html += `<div style="display:flex;justify-content: space-between;flex-wrap:nowarp;"><div>${name}:</div><div>${parseInt(item.data, 10)}${unit}</div></div>`
                            })
                            html += '</div>'
                            return html

                        }
                    },
                    dataZoom: {
                        show: true,
                        realtime: true,
                        bottom: 0,
                        height: 20,
                        startValue: this.chartData.startMonth,
                        endValue: this.chartData.endMonth
                    },
                    color: ['#61A0A8', '#2F4553', '#C23431', '#81C9AD'],
                    legend: {
                        data: ['投资版流量(㎡)', '实际流量(㎡)', '投资版价格(元/㎡)', '实际价格(元/㎡)'],
                        top: 0
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.chartData.xAxisData,
                            axisPointer: {
                                type: 'shadow'
                            },
                            axisLabel: {
                                interval: 0,
                                rotate: 40,
                                formatter: function(value) {
                                    return value.split('年')[1]
                                }
                            }
                        }
                    ],
                    grid: {
                        left: 50 // 调整这个属性
                    },
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    series: [
                        {
                            name: '投资版流量(㎡)',
                            type: 'bar',
                            barGap: 0,
                            data: this.chartData.flowList
                        },
                        {
                            name: '实际流量(㎡)',
                            type: 'bar',
                            data: this.chartData.actualFlow
                        },
                        {
                            name: '投资版价格(元/㎡)',
                            type: 'line',
                            data: this.chartData.priceList
                        },
                        {
                            name: '实际价格(元/㎡)',
                            type: 'line',
                            data: this.chartData.actualPrice
                        }
                    ]
                })
            }, 300)

        },
        async priceTend() {
            const params = {
                // landId: 'b1778795db454c419c514de09d55018a'
                landId: this.landId
            }
            await priceTend(params).then(res => {
                this.chartData.xAxisData = []
                res.forEach(item => {
                    const month = item.month < 10 ? '0' + item.month : item.month
                    this.chartData.xAxisData.push(item.year + '年' + month + '月')
                    this.chartData.flowList.push(item.investFlow || 0)
                    this.chartData.priceList.push(item.investPrice || 0)
                    this.chartData.actualFlow.push(item.actualFlow || 0)
                    this.chartData.actualPrice.push(item.actualPrice || 0)
                })
                if (res.length) {
                    const first = res[0]
                    const last = res[res.length - 1]
                    // const first = {
                    //     year: 2020,
                    //     month: 1
                    // }
                    const min = moment(this.getDate(first.year, first.month), 'YYYYMM')
                    const max = moment()
                    const diff = max.diff(min, 'months')
                    if (res.length >= 12) {
                        if (diff >= 11) {
                            this.chartData.endMonth = max.format('YYYY年MM月')
                            this.chartData.startMonth = max.subtract(11, 'months').format('YYYY年MM月')
                        } else {
                            this.chartData.startMonth = min.format('YYYY年MM月')
                            this.chartData.endMonth = min.add(11, 'months').format('YYYY年MM月')
                        }
                    } else {
                        console.log('moment', moment(this.getDate(first.year, first.month), 'YYYYMM'))
                        this.chartData.startMonth = moment(this.getDate(first.year, first.month), 'YYYYMM').format('YYYY年MM月')
                        this.chartData.endMonth = moment(this.getDate(last.year, last.month), 'YYYYMM').format('YYYY年MM月')
                    }
                    console.log('chartData', this.chartData)
                }

            })
        },
        getDate(year, month) {
            if (month < 10) {
                return year + '0' + month
            }
            return year + '' + month
        },
        switchMenu(type) {
            this.$emit('switchMenu', type)
        }
    }
}
</script>

<style lang="scss" scoped>
  .revive-month {
    font-family:PingFangTC-Medium,PingFangTC;
    background:rgba(248,248,248,1);
    overflow-y: auto;
    box-sizing: border-box;
    font-size:.28rem /* 28/100 */;
    width:100%;
    height:100%;
    // height:9999px;
    padding-bottom: 1.5rem /* 150/100 */;

    .mt20 {
      margin-top:.2rem /* 20/100 */
    }

    .c-red{
      color:#E40E0E;
    }

    .c-blue{
      color:#2761FF;
    }

    .view-detail {
      box-sizing: border-box;
      width:1.1rem /* 110/100 */;
      height:1.39rem /* 139/100 */;
      background:rgba(39,97,255,1);
      box-shadow:0 .08rem /* 8/100 */ .24rem /* 24/100 */ 0 rgba(39,97,255,0.5);
      border-radius:.1rem /* 10/100 */ 0 0 .1rem /* 10/100 */;
      position: fixed;
      right:0;
      bottom:2rem /* 200/100 */;
      text-align:center;
      padding:.23rem /* 23/100 */ 0;
      color:white;
      font-size:.2rem /* 20/100 */;
      font-weight:400;
      i {
        font-size:.4rem /* 4  0/100 */;
        margin-bottom:.1rem /* 10/100 */;
      }
      div {
        margin-bottom:.05rem /* 5/100 */;
      }
    }

    .report-menu {
      margin-top:.2rem /* 20/100 */;
    }

    .first-revive {
      padding:.2rem;
      background: white;
      margin-bottom:.2rem /* 20/100 */;
      .content {
        font-size:.28rem /* 28/100 */;
        color:rgba(51,51,51,1);
        margin-top:.2rem;
      }
    }

    .qp-table {
      width:100%;
      border:.01rem /* 1/100 */ solid rgba(239,239,239,1);
      border-bottom:none;
      tr {
        height:.8rem /* 80/100 */;
      }
      td {
        border-bottom:.01rem /* 1/100 */ solid rgba(239,239,239,1);
        padding:.2rem /* 10/100 */;
      }
      thead {
        tr {
          background:rgba(250,250,250,1);
          font: size .24rem /* 24/100 */;
          color:rgba(153,153,153,1);
        }
      }
      tbody {
        tr {
          font-weight:500;
          font-size:.24rem /* 24/100 */;
          color:rgba(51,51,51,1);
        }
      }
    }

    .bar-container {
      .bar-chart {
        // width:80%;
        height:6.5rem /* 395/100 */;
        margin:0 auto;
      }
    }
  }
</style>
